import request from '@/utils/httpRequest'

// 人才招聘-首页
export function ApiWebRecruit (params) {
  return request({
    url: request.adornUrl('/web/office/talent/index'),
    method: 'get',
    params: request.adornParams(params)
  })
}

// 人才招聘-加入我们-分页列表
export function ApiWebRecruitJoin (params) {
  return request({
    url: request.adornUrl('/web/office/recruit/list'),
    method: 'post',
    data: request.adornData(params)
  })
}

// 人才招聘-加入我们-详情
export function ApiWebRecruitJoinDetail (id) {
  return request({
    url: request.adornUrl('/web/office/recruit/info/' + id),
    method: 'get',
    params: request.adornParams()
  })
}
// 背景图接口
export function ApiWebRecruitImg () {
  return request({
    url: request.adornUrl(`/web/office/talent/background`),
    method: 'get',
    params: request.adornParams()
  })
}

// 人才招聘
export function ApiWebRecruitInfo () {
  return request({
    url: request.adornUrl(`/web/office/talent/recruit`),
    method: 'get',
    params: request.adornParams()
  })
}



// WEBPACK FOOTER //
// ./src/api/recruit.js